<template>
  <div class="card">
    <div class="card-header">
      <strong>Metabase Report</strong>
    </div>
    <div class="card-body">
      <div class="row mb15" v-for="(acc, index) in accordians" :key="index+acc.title">
        <div
          class="col-md-12 Expander__trigger"
          @click="setAccordian(acc)"
          :class="(acc.isOpen)? 'active' : 'beforeBorder' "
        >
          <strong>{{acc.name}}</strong>
          <svg
            class="Expander__trigger-Icon pull-right"
            :class="{open: (acc.isOpen)}"
            width="40"
            height="12"
            stroke="cornflowerblue"
          >
            <polyline points="12,2 20,10 28,2" stroke-width="3" fill="none" />
          </svg>
        </div>
        <div class="col-md-12 acc-content Expander__body" v-show="acc.isOpen">
          <div class="subContainer">
            <div v-if="acc.title==='search'">
              <div class="row mt10 mb15">
                <div class="col-md-6">
                  <!-- <button class="btn btn-primary" @click="showAllTemplates()">Select Template</button> -->
                  <div class="form-group">
                    <v-select
                      :options="allTemplates"
                      :placeholder="'Select Template'"
                      :label="'name'"
                      :value="selectedTemplate"
                      v-model="selectedTemplate"
                      @input="editTemplate()"
                    ></v-select>
                  </div>
                </div>
                <div class="col-md-6">
                  <!-- <h4>{{(editedTemplate && editedTemplate.name)? editedTemplate.name: ''}}</h4> -->
                </div>
              </div>
              <div class="row mt15" v-if="filterFields && filterFields.length>0">
                <div class="col-md-6">
                  <!-- <select class="form-control" v-model="selFilter['sector_name']">
                    <option value>Select Sector</option>
                    <option v-for="(sector, ind) in sectorList" :key="ind">{{sector}}</option>
                  </select> -->

                  <v-select
                    :options="sectorList"
                    :placeholder="'Select Sector'"
                    v-model="selFilter['sector_name']"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :label="'sector'"
                    track-by="title"
                    :preselect-first="true"
                    select-label
                    selectedLabel
                    deselectLabel
                  ></v-select>
                </div>
              </div>
              <div class="row mt15" v-if="filterFields && filterFields.length>0">
                <div
                  class="col-md-6"
                  v-for="(filter, ind) in getFilterFields"
                  :key="ind+filter.stored_value"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <!-- <label class="form-control-label">{{filterValid[filter.stored_value]['from']}}</label> -->
                        <input
                          type="text"
                          :placeholder="filter.display_name+' from'"
                          v-model="selFilter[filter.stored_value]['from']"
                          @blur="isValid(filter.stored_value, 'from')"
                          class="form-control"
                        />
                        <div
                          class="error"
                          v-if="!filterValid[filter.stored_value]['from']"
                        >Enter valid data</div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <!-- <label class="form-control-label">{{filter.display_name}} To</label> -->
                        <input
                          type="text"
                          :placeholder="filter.display_name+' to'"
                          v-model="selFilter[filter.stored_value]['to']"
                          @blur="isValid(filter.stored_value, 'to')"
                          class="form-control"
                        />
                        <div
                          class="error"
                          v-if="!filterValid[filter.stored_value]['to']"
                        >Enter valid data</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt15 mb15">
                <div class="col-md-12">
                  <button class="btn btn-success" @click="getFilteredData()">
                    <i class="fa fa-search"></i> Search
                  </button>
                </div>
              </div>
            </div>
            <div v-if="acc.title==='export'">
              <div class="row mt10 mb15">
                <div class="col-md-3">
                  <div class="form-group">
                    <input
                      class="form-control"
                      v-model="searchExportText"
                      placeholder="Search Field"
                      @keyup="searchExportField($event)"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <!-- <select class="form-control" v-model="selectedYears" multiple>
                    <option value>Select Years</option>
                    <option v-for="(year, ind) in years" :key="ind">{{year}}</option>
                  </select>-->
                  <v-select
                    :options="yearsList"
                    :placeholder="'Select years'"
                    v-model="selectedYears"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :label="'year'"
                    track-by="title"
                    :preselect-first="true"
                    select-label
                    selectedLabel
                    deselectLabel
                  ></v-select>
                </div>
              </div>
              <div class="row mb15" v-if="exportFields && exportFields.length>0">
                <div
                  class="col-md-4 mb10"
                  v-for="(exportField, ind) in exportFields"
                  :key="ind+exportField"
                >
                  <div class="row">
                    <div class="col-md-8">
                      <div class="form-group">
                        <div class="checkbox">
                          <label :for="'checkbox'+ind" class="form-check-label w-100">
                            <input
                              type="checkbox"
                              :id="'checkbox'+ind"
                              v-model="selExportField[exportField]['toShow']"
                              class="form-check-input"
                              @change="changeSortOrder(exportField, 1)"
                            />
                            {{exportField}}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <input
                        class="form-control"
                        placeholder="sort"
                        v-model="selExportField[exportField]['sortOrder']"
                        @change="changeSortOrder(exportField, 2)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt15 mb15">
                <div class="col-md-12">
                  <button class="btn btn-success" @click="exportData()">
                    <i class="fa fa-file-excel-o"></i> Export
                  </button>
                  <button class="btn btn-success" @click="showAddTemplate()">
                    <i class="fa fa-plus"></i> Create Template
                  </button>
                  <button class="btn btn-success" @click="saveTemplate()">
                    <i class="fa fa-save"></i> Save Template
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt15 mb15" v-if="searchData.length>0">
        <div class="col-md-9"></div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              class="form-control"
              v-model="searchText"
              placeholder="Search company"
              @keyup="filteredList($event)"
            />
          </div>
        </div>
      </div>
      <div class="row mb15">
        <div class="table-responsive mt15 mb-15 app" v-dragscroll="true">
          <table
            id="report"
            class="table table-bordered app-inner"
            style="font-size: 11px;"
            v-if="rawData && rawData.length"
          >
            <thead v-if="tableFields.length>0">
              <tr>
                <th>Sr.</th>
                <th
                  @click="sortColumn(field, index)"
                  style="font-size:.92em"
                  class="data-cell column-sort"
                  v-for="(field, index, key) in tableFields"
                  v-bind:key="'field'+field+index+key"
                >
                  {{field.name}}
                  <!-- <span v-if="field.isSortable">
                  <i
                    class="fa fa-caret-down"
                    v-if="(field.sort_order == 1 || field.sort_order == 0)"
                  ></i>
                  <i
                    class="fa fa-caret-up"
                    v-else-if="(field.sort_order == 2 || field.sort_order == 0)"
                  ></i>
                  </span>-->
                </th>
              </tr>
            </thead>
            <tbody v-if="tableFields.length>0">
              <tr v-for="(row, index, key) in rawData" v-bind:key="'row'+row+index">
                <td>{{(index+1)}}</td>
                <td v-for="(field, ind) in tableFields" v-bind:key="ind+'-td-'+index+key">
                  <span
                    v-if="field.title === 'q1_a_b_greater' || field.title === 'p11_quarterly_trends' || field.title === 'sector_name' || field.title === 'co_code' || field.title === 'name' || field.title === 'market_capitalization'"
                  >
                    <span v-if="field.isLink">
                      <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                    </span>
                    <span
                      v-else
                    >{{(field.type === 'number')? getChecknFixed(row[field.title]): row[field.title]}}</span>
                  </span>
                  <span
                    v-else
                  >{{(field.type === 'number')? getChecknFixed(row[field.title]): row[field.title]}}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            v-if="rawData && rawData.length==0"
            class="alert alert-danger"
            role="alert"
          >No data found!</div>
        </div>
      </div>
      <!-- <metabaseTemplates
        :show.sync="show"
        ref="smallModal"
        v-bind:large="true"
        :cancelClass="'btn btn-secondary'"
        :templatesList="allTemplates"
        @selectedTemplate="editTemplate($event)"
        :cancel="closeTemplateModal"
      ></metabaseTemplates>-->
      <metabaseAddTemplate
        :show.sync="showAddTemp"
        ref="addtemp"
        v-bind:small="true"
        :cancelClass="'btn btn-secondary'"
        @saveTemplateName="createTemplate($event)"
        :cancel="closeTemplateModal"
      ></metabaseAddTemplate>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { pCommonMixins } from "../../assets/mixins/pcommon.js";
import metabaseTemplates from "@/components/templates.vue";
import metabaseAddTemplate from "@/components/addTemplate.vue";
import Datepicker from "vuejs-datepicker";

export default {
  components: { Datepicker, metabaseTemplates, metabaseAddTemplate },
  mixins: [commonMixins, pCommonMixins],
  created() {
    this.getAllFields();
  },
  data() {
    return {
      open: false,
      accordians: [
        { title: "search", name: "Search Templates", isOpen: true },
        { title: "export", name: "Export Output", isOpen: false }
      ],
      selRowInd: 0,
      allFields: [],
      filterFields: [],
      exportFields: [],
      sectorList: [],
      years: [],
      yearsList: [],
      searchExportFields: [],
      defaultFields: [],
      sectorname: [],
      selectedYears: [],
      selFilter: {},
      filterValid: {},
      selExportField: {},
      tableFields: [],
      rawData: {},
      searchData: [],
      searchText: "",
      searchExportText: "",
      show: false,
      allTemplates: [],
      showAddTemp: false,
      selectedTemplate: "",
      selectedTemplateName: "",
      editedTemplate: null
    };
  },
  methods: {
    setAccordian(acc) {
      acc.isOpen = !acc.isOpen;
    },
    getAllFields() {
      let myself = this;
      http.get("report/fields", {}, function(error, response) {
        console.log(error, response);
        if (!error) {
          myself.allFields = response;
          myself.filterFields = response.filter_fields;
          myself.sectorList = response.sectors;
          myself.years = response.years;
          myself.exportFields = response.export_fields;
          myself.searchExportFields = myself.exportFields;
          myself.showAllTemplates();
          myself.setFilters();
          myself.setExportFields();
          // myself.addSector();
          myself.getYears();
        }
      });
    },
    setFilters() {
      this.filterFields.forEach((val, key) => {
        // console.log(val, this);
        this.filterFields[key]["type"] =
          val.stored_value === "sector_name" ? "string" : "number";
        if (val.stored_value !== "sector_name") {
          this.selFilter[val.stored_value] = { from: "", to: "" };
          this.selFilter[val.stored_value]["from"] = "";
          this.selFilter[val.stored_value]["to"] = "";
          this.filterValid[val.stored_value] = { from: true, to: true };
          this.filterValid[val.stored_value]["from"] = true;
          this.filterValid[val.stored_value]["to"] = true;
        } else {
          this.selFilter[val.stored_value] = "";
        }
      });
      console.log(this.filterFields, this.selFilter);
    },
    setExportFields() {
      this.exportFields.forEach((val, key) => {
        this.selExportField = !this.selExportField ? {} : this.selExportField;
        this.selExportField[val] = { toShow: false, sortOrder: "" };
      });
      console.log(this.selExportField);
    },
    searchExportField(e) {
      if (this.searchExportText.length > 2 || e.keyCode === 13) {
        this.exportFields = this.searchExportFields.filter(field => {
          console.log("export field", field);
          return field
            .toLowerCase()
            .includes(this.searchExportText.toLowerCase());
        });
      }
      if (
        this.searchExportText === null ||
        this.searchExportText === "" ||
        this.searchExportText.length <= 2
      ) {
        this.exportFields = this.searchExportFields;
        return this.exportFields;
      }
    },
    getFilteredData() {
      console.log(
        this.editedTemplate !== null,
        this.checkIfChangesMade(this.selFilter, 1)
      );
      if (
        this.editedTemplate !== null ||
        this.checkIfChangesMade(this.selFilter, 1)
      ) {
        const myself = this;
        let data = {};
        if (this.editedTemplate !== null) {
          data = myself.editedTemplate;
        } else {
          // myself.addSector();
          data = { name: "", filters: myself.selFilter };
        }
        console.log(myself.selFilter); //{filters: this.selFilter}
        http.post("report", data, function(error, response) {
          console.log("Response", response);
          if (!error) {
            if (response.responseType === "success") {
              myself.rawData = response.data;
              myself.searchData = response.data;
              if (myself.rawData.length) {
                const tableFields = [];
                const fields = Object.keys(myself.rawData[0]);
                fields.forEach((val, key) => {
                  tableFields.push({
                    title: val,
                    name: myself.getCustomLabel(val)
                      ? myself.getCustomLabel(val)
                      : myself.getLabel(val),
                    isLink: val === "companyname" ? 1 : 0,
                    sort_order:
                      val === "co_code"
                        ? 1
                        : val === "companyname"
                        ? 2
                        : val === "sectorname"
                        ? 3
                        : val === "market_capitalization"
                        ? 4
                        : 7,
                    type:
                      val === "co_code" ||
                      val === "companyname" ||
                      val === "sectorname"
                        ? "string"
                        : "number"
                  });
                });
                myself.tableFields = myself.sorted_fields_asc(
                  tableFields,
                  "sort_order"
                );
              }
              myself.accordians[0].isOpen = false;
              myself.accordians[1].isOpen = false;
              console.log(myself.tableFields, myself.rawData);
            } else {
              console.log("No data");
              myself.clearData();
            }
          }
        });
      } else {
        this.$toastr.error(
          "Please select any template or filter to search data",
          {},
          ""
        );
      }
    },
    exportData() {
      console.log(
        this.selectedYears,
        this.editedTemplate,
        this.selFilter,
        this.selExportField
      );
      // return;
      console.log(
        this.checkIfChangesMade(this.selFilter, 1),
        this.checkIfChangesMade(this.selExportField, 2)
      );
      if (
        this.editedTemplate !== null ||
        this.checkIfChangesMade(this.selFilter, 1) ||
        this.checkIfChangesMade(this.selExportField, 2)
      ) {
        // this.addSector();
        const myself = this;
        const name =
          this.editedTemplate !== null ? myself.editedTemplate.name : "";
        const data = {
          name: name,
          filters: myself.selFilter,
          exportFields: myself.selExportField,
          years: myself.selectedYears
        };
        // console.log(JSON.stringify(data));
        http.post("report?export=true", data, function(error, response) {
          console.log("Response", response);
          if (!error) {
            if (response.responseType === "success") {
              window.open(response.download_link, "_blank");
            }
          }
        });
      } else {
        this.$toastr.error(
          "Please select any one template or filters to export data",
          {},
          ""
        );
      }
    },
    showAddTemplate() {
      this.$refs.addtemp.open();
    },
    createTemplate(val) {
      console.log("Template Name", val);
      console.log(this.selFilter, this.selExportField);
      if (
        this.checkIfChangesMade(this.selFilter, 1) ||
        this.checkIfChangesMade(this.selExportField, 2)
      ) {
        const data = {
          name: val,
          filters: this.selFilter,
          exportFields: this.selExportField,
          years: this.selectedYears
        };
        console.log(data);
        const myself = this;
        http.post("report/templates", data, function(error, response) {
          console.log(response, error);
          if (!error) {
            if (response && response.responseType === "success") {
              myself.$toastr.success(response.msg, {}, "");
              myself.showAllTemplates();
            } else {
              myself.$toastr.error(response.msg, {}, "");
            }
          }
        });
      } else {
        this.$toastr.error(
          "Please select filters or fields to create template",
          {},
          ""
        );
      }
    },
    saveTemplate() {
      if (this.editedTemplate !== null) {
        // this.addSector();
        const data = {
          name: this.editedTemplate.name,
          filters: this.selFilter,
          years: this.selectedYears,
          exportFields: this.selExportField,
          _id: this.editedTemplate._id
        };
        console.log(data);
        const myself = this;
        http.post(
          "report/templates/" + myself.editedTemplate._id,
          data,
          function(error, response) {
            console.log(response, error);
            if (!error) {
              if (response && response.responseType === "success") {
                myself.$toastr.success(response.msg, {}, "");
                myself.showAllTemplates();
              } else {
                myself.$toastr.error(response.msg, {}, "");
              }
            }
          }
        );
      } else {
        this.$toastr.error("Please select template to save");
      }
    },
    editTemplate() {
      const val = this.selectedTemplate;
      this.rawData = {};
      console.log(val);
      if (val !== null && val !== "") {
        let myself = this;
        // myself.editedTemplate = val;
        // myself.selFilter = val.filters ? val.filters : {};
        // myself.selExportField = val.exportFields ? val.exportFields : {};
        // myself.selectedYears = val.years ? val.years : [];
        console.log(
          myself.selFilter,
          myself.selExportField,
          myself.selectedYears
        );
        // myself.sectorname = val.filters.sector_name;
        myself.clearData();
        http.get("report/templates/" + val._id, {}, function(error, response) {
          if (!error) {
            if (response) {
              myself.editedTemplate = response;
              myself.selFilter = response.filters ? response.filters : {};
              myself.selExportField = response.exportFields
                ? response.exportFields
                : {};
              myself.selectedYears = response.years ? response.years : [];
              myself.clearData();
            } else myself.$toastr.error("Template does not exists", {}, "");
          } else myself.$toastr.error("Oops, something went wrong. Try again later.", {}, "");
        });
      } else {
        this.selectedYears = [];
        this.setFilters();
        this.setExportFields();
        this.editedTemplate = null;
        this.selectedTemplate = "";
      }
    },
    closeTemplateModal() {
      console.log("Closed");
    },
    changeSortOrder(field, type) {
      console.log(
        field,
        this.selExportField[field].toShow,
        this.selExportField[field].sortOrder,
        this.selExportField[field].sortOrder !== "",
        this.selExportField[field].sortOrder === ""
      );
      if (type === 2) {
        if (this.selExportField[field].sortOrder !== "") {
          this.selExportField[field].toShow = true;
        }
      } else if(type === 1){
        if (!this.selExportField[field].toShow) {
          this.selExportField[field].sortOrder = '';
        }
      }
      console.log(
        field,
        this.selExportField[field].toShow,
        this.selExportField[field].sortOrder
      );
    },
    filteredList(e) {
      if (this.searchText === null || this.searchText === "") {
        this.rawData = this.searchData;
        return this.rawData;
      } else if (this.searchText.length <= 2) {
        this.rawData = this.searchData;
        return this.rawData;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawData = this.searchData.filter(rd => {
          return (
            rd.co_code.toLowerCase().includes(this.searchText.toLowerCase()) ||
            (rd.companyname
              ? rd.companyname
                  .toLowerCase()
                  .includes(this.searchText.toLowerCase())
              : false)
          );
        });
      }
    },
    clearData() {
      this.rawData = {};
      this.searchData = [];
      this.tableFields = [];
    },
    // addSector() {
    //   if (this.sectorname !== "") {
    //     this.selFilter["sector_name"] = this.sectorname;
    //   } else {
    //     this.selFilter["sector_name"] = "";
    //   }
    // },
    getYears() {
      const years = this.years;
      years.forEach(val => {
        console.log(val);
        this.yearsList.push("" + val + "");
      });
      console.log(this.yearsList);
    },
    getSelectedYears() {
      let selectedYears = [];
      this.selectedYears.forEach(val => {
        selectedYears.push(val.year);
      });
      return selectedYears;
    },
    checkIfChangesMade(data, type) {
      let isChanged = false;
      if (type === 1) {
        this.filterFields.forEach((val, key) => {
          if (val.stored_value !== "sector_name") {
            if (
              this.selFilter[val.stored_value]["from"] !== "" &&
              this.selFilter[val.stored_value]["to"] !== ""
            ) {
              isChanged = true;
              return;
            }
          } else {
            if (this.selFilter[val.stored_value] !== "") {
              isChanged = true;
              return;
            }
          }
        });
      } else if (type === 2) {
        this.exportFields.forEach((val, key) => {
          if (
            this.selExportField[val]["toShow"] &&
            this.selExportField[val]["sortOrder"] !== ""
          ) {
            isChanged = true;
            return;
          }
        });
      }
      return isChanged;
    },
    isValid(val, type) {
      const value = this.selFilter[val][type];
      if (value !== "" && !value.match(/^[+-]?((\.\d+)|(\d+(\.\d+)?))$/)) {
        console.log("Not valid");
        this.filterValid[val][type] = !this.filterValid[val][type];
        this.selFilter[val][type] = "";
      } else {
        this.filterValid[val][type] = true;
      }
      console.log(this.filterValid);
    },
    showAllTemplates() {
      var myself = this;
      http.get("report/templates", {}, function(error, response) {
        if (!error) {
          if (response && response.length) {
            myself.allTemplates = response;
            // myself.$refs.smallModal.open();
          } else myself.$toastr.success("No template added", {}, "");
        } else myself.$toastr.error("Oops, something went wrong. Try again later.", {}, "");
      });
    }
  },
  watch: {},
  computed: {
    getFilterFields() {
      return this.filterFields.filter(function(row, index) {
        return row.type === "number";
      });
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
.modal {
  display: block;
}

.modal-dialog,
.modal-backdrop {
  transition: all 0.5s ease;
}

.modal-enter .modal-dialog,
.modal-leave-active .modal-dialog {
  opacity: 0;
  transform: translateY(-30%);
}

.modal-enter .modal-backdrop,
.modal-leave-active .modal-backdrop {
  opacity: 0;
}

.modal-backdrop {
  opacity: 0.5;
}

//Modal styles

.modal-header {
  height: auto;
  padding: 0 1.6rem;
  border-bottom: 2px solid #eee;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
}

.modal-content {
  border-radius: 0;
}

.modal-footer {
  justify-content: center;
  padding: 0 2px;
  padding-bottom: 5px;
  flex-wrap: wrap;
  .btn {
    margin: 0 10px 20px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/metabase/reports.vue